module.exports = __webpack_public_path__ + "static/dog-bcef702e997a1b1a98f7808eb27b95c7.png";